//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RightDrawer from "@/components/RightDrawer/Filters.vue";

export default {
  name: "Filters",
  components: {
    RightDrawer,
  },
  methods: {
    clearFilters: function () {
      this.$store.commit("clearFilters");
    },
  }
};
